<template>
  <picker-field :label="label" :isNeedInput="isNeedInput" :is-focus="isFocus" :value="value" title="选择项目名称" @onchange="onchange" ref="picker" @open="onSearch">
    <template v-slot:tbar>
      <search-bar
        @search="onSearch"
        @focus="onFocusChange"
        name="pj_code,de_name"
        placeholder="输入项目编号、名称进行查找"
        ref="searchBar"
      />
    </template>
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.pj_id"
        @click="select(item)"
      >
        <div class="weui-cell__bd">
          <p>
            {{item.pj_dename}}
            <span class="list-item-status" v-if="item.pj_product_type">{{item.pj_product_type}}</span>
          </p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.pj_code}}</p>
        </div>
      </div>
    </scroll-list>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import querylist from "@/mixins/querylist.js";

export default {
  components: {
    PickerField,
    SearchBar,
    ScrollList
  },
  mixins: [querylist],
  props: {
    label: {
      type: String,
      default: "项目名称"
    },
    isNeedInput: {
      type: Boolean,
      default: false
    },
    value: String
  },
  data() {
    return {
      isFocus: false,
      listUrl: "/api/plm/proj/list",
      defaultCondition: [
        {
          field: "pj_statuscode",
          operation: "=",
          value: "AUDITED"
        },
      ]
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.pj_dename);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onchange(value) {
      var me = this
      me.$emit("onchange", value);
    },
    onFocusChange(focus) {
      this.isFocus = focus;
    }
  }
};
</script>